import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { zodSchema } from "@/lib/utils/zod";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { encodePhone, getErrorMessage } from "@/lib/utils";
import { toast } from "react-toastify";
import { sendOtp } from "../services";
import { trackProductEvent } from "@/lib/analytics/product";

const forgotPasswordSchema = z.object({
  phone: zodSchema.phone,
});

export type ForgotPasswordPayloadType = z.infer<typeof forgotPasswordSchema>;

export function useForgotPasswordForm() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const methods = useForm<ForgotPasswordPayloadType>({
    resolver: zodResolver(forgotPasswordSchema),
  });

  const { register, handleSubmit, formState } = methods;
  const { errors } = formState;

  const onSubmit = handleSubmit(async (data: ForgotPasswordPayloadType) => {
    setLoading(true);
    const res = await sendOtp(data);

    if (!res.error) {
      trackProductEvent("Forgot Password", {
        Status: "Started",
      });
      localStorage.setItem("phone", data.phone);
      router.push(`/otp?type=forgot`);
    } else {
      toast.error(getErrorMessage(res));
      setLoading(false);
    }
  });

  return {
    errors,
    methods,
    loading,
    onSubmit,
    register,
  };
}
